import {
  AdelantoListQuerySchema,
  AdelantoSchema,
  CreateAdelantoRequestSchema,
  CreatePagoRequestSchema,
  PagoListQuerySchema,
  PagoSchema,
  SaldoGuardiaSchema,
  UpdateAdelantoRequestSchema,
  UpdatePagoRequestSchema,
} from '@visep/shared-types/pagos';
import type { SaldoGuardia } from '@visep/shared-types/pagos';
import type { Helpers } from './internal.js';
import { makeCrudResource } from './internal.js';

export function createPagosResource({ request }: Helpers) {
  const pagos = makeCrudResource(request, {
    basePath: '/api/pagos',
    schema: PagoSchema,
    listQuerySchema: PagoListQuerySchema,
    createSchema: CreatePagoRequestSchema,
    updateSchema: UpdatePagoRequestSchema,
  });
  const adelantos = makeCrudResource(request, {
    basePath: '/api/adelantos',
    schema: AdelantoSchema,
    listQuerySchema: AdelantoListQuerySchema,
    createSchema: CreateAdelantoRequestSchema,
    updateSchema: UpdateAdelantoRequestSchema,
  });
  return {
    listPagos: pagos.list,
    getPago: pagos.get,
    createPago: pagos.create,
    updatePago: pagos.update,
    deletePago: pagos.delete,
    listAdelantos: adelantos.list,
    getAdelanto: adelantos.get,
    createAdelanto: adelantos.create,
    updateAdelanto: adelantos.update,
    deleteAdelanto: adelantos.delete,
    async getSaldo(guardiaId: string): Promise<SaldoGuardia> {
      return SaldoGuardiaSchema.parse(
        await request('GET', `/api/pagos/saldo/${encodeURIComponent(guardiaId)}`),
      );
    },
  };
}
